import { render, staticRenderFns } from "./FeaturedListTable.vue?vue&type=template&id=39d8b3eb&scoped=true&"
import script from "./FeaturedListTable.vue?vue&type=script&lang=js&"
export * from "./FeaturedListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d8b3eb",
  null
  
)

export default component.exports